<template>
  <div id="home">
    <header-menu curPage="home"></header-menu>
    <div class="header-section">
      <div class="header-content">
        <div class="title">
          KBmob 轻量高效流量变现平台
        </div>
        <div class="description">
          以技术驱动流量价值，为开发者提供高效、可靠的变现解决方案
        </div>
        <div class="btn" @click="goToAdmin">
          立即注册
        </div>
      </div>
      <div class="image-grid">
        <img src="../../public/pic1@2x.png" alt="用户场景1" />
        <img src="../../public/pic2@2x.png" alt="用户场景2" />
        <img src="../../public/pic3@2x.png" alt="用户场景3" />
        <img src="../../public/pic4@2x.png" alt="用户场景4" />
        <img src="../../public/pic_5@2x.png" alt="用户场景5" />
      </div>
      <div class="stats-section">
        <div class="stat-item">
          <div class="stat-number">5000+</div>
          <div class="stat-label">合作APP</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">1000+</div>
          <div class="stat-label">优质广告主</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">5000万+</div>
          <div class="stat-label">覆盖用户</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">100亿+</div>
          <div class="stat-label">日请求量</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">5000+</div>
          <div class="stat-label">合作APP</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">1000+</div>
          <div class="stat-label">优质广告主</div>
        </div>
      </div>
    </div>
    <div class="advantage-section" id="advantage-section">
      <div class="advantage-box">
        <div class="title">平台核心优势</div>
        <div class="advantage-description" style="margin-top: 20px; margin-bottom: 65px; font-size: 20px; color: #8C8C8C; text-align: center;">
          从资源到技术，从服务到收益，为开发者提供高效、可靠的变现解决方案
        </div>
        <div class="advantage-list">
          <div class="advantage-item">
            <div class="advantage-icon" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
              <span class="icon-number">01</span>
              <img src="../../public/icon_resource_60@2x.png" alt="优势图标" style="width: 50px; height: 50px;">
            </div>
            <div class="advantage-content">
              <div class="advantage-title">优质预算资源</div>
              <div class="advantage-description">合作1000+优质广告主，覆盖KA品牌、电商、网服、生活服务等行业，预算单价高，素材优质。</div>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
              <span class="icon-number">02</span>
              <img src="../../public/icon_revenue_60@2x(1).png" alt="优势图标" style="width: 50px; height: 50px;">
            </div>
            <div class="advantage-content">
              <div class="advantage-title">AI驱动高收益</div>
              <div class="advantage-description">通过AI技术实现智能竞价与动态调优，深度挖掘流量价值，为开发者提供稳定且领先的收益保障。</div>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
              <span class="icon-number">03</span>
              <img src="../../public/icon_fill_60@2x.png" alt="优势图标" style="width: 50px; height: 50px;">
            </div>
            <div class="advantage-content">
              <div class="advantage-title">98%+填充率保障</div>
              <div class="advantage-description">通过AI智能调度引擎整合海量优质广告源，实现供需的高效实时匹配，确保流量高填充。</div>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
              <span class="icon-number">04</span>
              <img src="../../public/icon_service_60@2x.png" alt="优势图标" style="width: 50px; height: 50px;">
            </div>
            <div class="advantage-content">
              <div class="advantage-title">1对1定制服务</div>
              <div class="advantage-description">1对1专属运营，7x12小时即时响应，深度定制变现方案，从技术接入到收益提升为开发者全程护航。</div>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
              <span class="icon-number">05</span>
              <img src="../../public/icon_revenue_60@2x.png" alt="优势图标" style="width: 50px; height: 50px;">
            </div>
            <div class="advantage-content">
              <div class="advantage-title">稳定省心的结算</div>
              <div class="advantage-description">透明合规的结算体系与高效的电子化流程，确保每一笔收益清晰可查、快速到账，结算稳定又省心。</div>
            </div>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
              <span class="icon-number">06</span>
              <img src="../../public/icon_safety_60@2x.png" alt="优势图标" style="width: 50px; height: 50px;">
            </div>
            <div class="advantage-content">
              <div class="advantage-title">SDK安全可靠</div>
              <div class="advantage-description">KBmob SDK 已通过中国信息通信研究院的严格评测，兼具高安全性与强稳定性，接入便捷。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="process-section" id="process-section">
      <div class="process-box">
        <div class="title">3步快速接入，开启高收益变现</div>
        <div style="margin-top: 20px; margin-bottom: 70px; font-size: 20px; color: #8C8C8C; text-align: center;">
          全程指引，新手也能轻松上手
        </div>
        <div class="process-steps">
          <div class="process-step">
            <div class="step-icon">
              <img class="step-number" src="../../public/icon_register_80@2x.png" alt="测试图标" style="width: 80px; height: 80px;">
            </div>
            <div class="step-title">01 注册开户</div>
            <div class="step-description">3分钟完成账号注册，12小时内快速审核</div>
          </div>
          <div class="process-step">
            <div class="step-icon">
              <img class="step-number" src="../../public/icon_integration_80@2x.png" alt="测试图标" style="width: 80px; height: 80px;">
            </div>
            <div class="step-title">02 SDK集成</div>
            <div class="step-description">参考详细文档，快速完成SDK集成与广告位配置</div>
          </div>
          <div class="process-step">
            <div class="step-icon">
              <img class="step-number" src="../../public/icon_test_80@2x.png" alt="测试图标" style="width: 80px; height: 80px;">
            </div>
            <div class="step-title">03 测试上线</div>
            <div class="step-description">技术验证通过后正式上线，实时统计收益</div>
          </div>
        </div>
      </div>
    </div>
    <div class="partner-section" id="partner-section">
      <div class="partner-box">
        <div class="title">他们都在用 KBmob</div>
        <div style="margin-top: 20px; margin-bottom: 70px; font-size: 20px; color: #8C8C8C; text-align: center;">
          为不同开发者提供针对性的、精细的解决方案，帮助应对不同行业痛点诉求
        </div>
        <div class="partner-showcase">
          <div class="partner-item">
            <img src="../../public/pic_1@2x.png" alt="合作伙伴1" />
            <div class="partner-name">行业/政府类-某公共出行APP</div>
            <div class="partner-desc">“从素材安全审核到快应用体验优化，KBmob团队一站式解决了我们变现的核心痛点，既保障了用户体验，又显著提升了收益，运营效率翻倍。”</div>
          </div>
          <div class="partner-item">
            <img src="../../public/pic_2@2x.png" alt="合作伙伴2" />
            <div class="partner-name">头部互联网类 - 某地图APP</div>
            <div class="partner-desc">“导航场景变现要求很高，需要考虑合规、安全、用户体验、场景化适配等多重因素，感谢KBmob团队给我们提供了很多专业建议和定制化服务。”</div>
          </div>
          <div class="partner-item">
            <img src="../../public/pic_3@2x.png" alt="合作伙伴3" />
            <div class="partner-name">网赚工具类 - 某休闲游戏APP</div>
            <div class="partner-desc">“KBmob的场景化策略让广告和玩法完美融合，除了激励视频，他们的运营团队还帮助拓展了信息流、插屏等多种场景组合策略，收益提升非常明显。”</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ad-developers-section">
      <div class="ad-developers-box">
        <div class="title">头部广告主聚集 高填充 高收益</div>
        <div class="description">我们帮助开发者一站式对接行业主流移动广告平台，轻松获取优质广告预算资源</div>
        <div class="ad-logos-grid">
          <div class="ad-logo-item" v-for="i in 21" :key="i">
            <img :src="`../../public/icon/advert_${i}.png`" alt="App Logo" />
          </div>
        </div>
      </div>
    </div>
    <div class="app-developers-section">
      <div class="app-developers-box">
        <div class="title">头部APP开发者的共同变现选择</div>
        <div class="description">我们与工具、安防、出行、游戏、影音视频、网赚、政府类的头部媒体达成合作，助推他们实现流量变现和商业增长</div>
        <div class="app-logos-grid">
          <div class="app-logo-item" v-for="i in 35" :key="i">
            <img :src="`../../public/icon/logo_${i}.png`" alt="App Logo" />
          </div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
  </div>
</template>

<script>
import HeaderMenu from '../components/header-menu.vue';
import FooterMenu from '../components/footer-menu.vue';
export default {
  name:'home',
  components: {
    HeaderMenu,
    FooterMenu
  },
  data() {
    return {
      curPage: 'home',
      curProduct: '1',
      curPartner: '1',
      curScene: '1'
    }
  },
  created() {
    document.title = 'KBmob-首页';
  },
  methods: {
    goUrl(url){
      window.open(url);
    },
    goToAdmin(){
      this.goUrl('https://admin.kuaibian.top/register');
    }
  }
}
</script>

<style lang="less">
#home {
  background-color: #FFFFFF;
  .header-section {
    padding: 60px 0;
    width: 100%;
    height: 840px;
    margin-bottom: 180px;
    background: linear-gradient( 180deg, #E1FFF5 0%, rgba(225,255,245,0) 100%);
    .header-content {
      text-align: center;
      padding: 0 20px;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 40px;
        color: #26233B;
        line-height: 50px;
        text-align: center;
        font-style: normal;
      }
      .description {
        margin-top: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #797889;
        line-height: 24px;
        text-align: center;
        font-style: normal;
      }
      .btn {
        background: #10D294;
        cursor: pointer;
        margin: 20px auto 0;
        width: 160px;
        height: 48px;
        border-radius: 8px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 48px;
        text-align: center;
        font-style: normal;
      }
    }
    .image-grid {
      margin: 150px 0;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 10px;
      padding: 20px 10px;
      max-width: 100%;
      img {
        width: 260px;
        height: 345px;
        object-fit: cover;
        border-radius: 18px;
        transition: transform 0.3s ease;
        cursor: pointer;
      }
      img:hover {
        transform: scale(1.3);
      }
    }
    .stats-section {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      padding: 66px 20px;
      background-color: #FFFFFF;
      .stat-item {
        text-align: center;
        margin: 0 20px 20px;
      }
      .stat-number {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 28px;
        color: #10D294;
        line-height: 36px;
      }
      .stat-label {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        margin-top: 8px;
      }
    }
  }
  .advantage-section {
    width: 100%;
    padding: 80px 0;
    background: #FFFFFF;
    .advantage-box {
      width: 80%;
      margin: 0 auto;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 32px;
        color: #26233B;
        text-align: center;
        font-style: normal;
        margin-bottom: 20px;
      }
      .subtitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #797889;
        text-align: center;
        font-style: normal;
        margin-bottom: 60px;
      }
      .advantage-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 40px;
      }
      .advantage-item {
        padding: 30px;
        background: #FFFFFF;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
        }
      }
      .advantage-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
      }
      .icon-number {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 17px;
        color: #10D294;
      }
      .advantage-icon {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        margin-bottom: 16px;
      }
      .advantage-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 10px;
      }
      .advantage-description {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }
    }
  }
  .process-section {
    width: 100%;
    padding: 80px 0;
    background: #FFFFFF;
    .process-box {
      width: 80%;
      margin: 0 auto;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 32px;
        color: #26233B;
        text-align: center;
        font-style: normal;
        margin-bottom: 10px;
      }
      .process-steps {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
      }
      .process-step {
        text-align: center;
        width: 200px;
        margin-bottom: 40px;
      }
      .step-icon {
        width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 20px;
      }
      .step-number {
        width: 80px;
        height: 80px;
      }
      .step-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 10px;
      }
      .step-description {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }
    }
  }
  .partner-section{
    width: 100%;
    padding: 80px 0;
    background: #FFFFFF;
    .partner-box {
      width: 80%;
      margin: 0 auto;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 32px;
        color: #26233B;
        text-align: center;
        font-style: normal;
        margin-bottom: 60px;
      }
      .partner-showcase {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
      }
      .partner-item {
        text-align: center;
        width: 320px;
        margin-bottom: 10px;
      }
      .partner-item img {
        width: 280px;
        height: 210px;
        object-fit: contain;
        margin-bottom: 20px;
      }
      .partner-name {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 20px;
        margin-bottom: 5px;
      }
      .partner-desc {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 18px;
      }
    }
  }
  .scene-section {
    width: 100%;
    height: 1010px;
    background: #FFFFFF;
    .scene-box {
      width: 66%;
      margin-left: 17%;
      padding-top: 100px;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 46px;
        color: #1A233B;
        text-align: left;
        font-style: normal;
      }
      .description {
        margin-top: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #797889;
        text-align: left;
        font-style: normal;
      }
      .scene-center{
        margin-top: 40px;
        .tab-line {
          display: flex;
          height: 68px;
          background: #EBF5FF;
          border-radius: 52px;
          align-items: center;
          .tab-item{
            flex: 1;
            display: flex;
            justify-content: center;
            .tab-btn {
              cursor: pointer;
              padding: 2px 30px;
              height: 35px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 18px;
              color: #333333;
              line-height: 35px;
              text-align: center;
              font-style: normal;
            }
            .tab-btn-active{
              background: #C4E9FB;
              border-radius: 32px;
              font-weight: bold;
            }
          }
        }
        .content-box {
          margin-top: 80px;
          display: flex;
          position: relative;
          height: 600px;
          .icon {
            position: absolute;
            display: block;       /* 消除图片默认的底部间隙 */
            height: 500px;        /* 固定高度（按需调整数值） */
            width: auto;          /* 宽度自适应（可不写，默认行为） */
            object-fit: contain;  /* 保持图片比例完整显示 */
            right: 0;
            bottom: 0;
          }
          .content-left {
            flex: 2.5;
            .main-box {
              padding-left: 20px;
              padding-right: 60px;
              .main-title {
                font-family: PingFangSC, PingFang SC;
                font-weight: bold;
                font-size: 40px;
                color: #333333;
                line-height: 40px;
                letter-spacing: 2px;
                text-align: left;
                font-style: normal;
              }
              .main-descript {
                margin-top: 30px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #67648E;
                line-height: 32px;
                text-align: left;
                font-style: normal;
              }
              .main-sub-label {
                margin-top: 70px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 18px;
                color: #6B6B7C;
                line-height: 18px;
                text-align: left;
                font-style: normal;
              }
              .main-sub-value {
                margin-top: 24px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #333333;
                line-height: 24px;
                text-align: left;
                font-style: normal;
              }
              .main-btn {
                cursor: pointer;
                margin-top: 80px;
                width: 205px;
                height: 62px;
                background: #26B9EA;
                border-radius: 2px;
                font-family: PingFangSC, PingFang SC;
                font-weight: bold;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 62px;
                text-align: center;
                font-style: normal;
              }
            }
          }
          .content-right {
            flex: 1;
          }
        }
      }
    }
  }
  .skill-section {
    width: 100%;
    height: 800px;
    background: #F2F2F6;
    .skill-box {
      width: 66%;
      margin-left: 17%;
      padding-top: 100px;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 46px;
        color: #1A233B;
        text-align: left;
        font-style: normal;
      }
      .description {
        margin-top: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #797889;
        text-align: left;
        font-style: normal;
      }
      .skill-center{
        margin-top: 65px;
        .item-line {
          display: flex;
          justify-content: center;
          margin-bottom: 40px;
          .item {
            width: 303px;
            height: 185px;
            background: #FFFFFF;
            box-shadow: 0px 2px 30px 0px rgba(129,138,164,0.2);
            border-radius: 10px;
            &:not(:last-child) {
              margin-right: 20px;
            }
            .item-content {
              padding: 20px;
              .content-title {
                height: 50px;
                background: #F5FAFF;
                border-radius: 2px;
                display: flex;
                justify-content: center;
                align-items: center;
                .icon {
                  width: 18px;
                  height: 18px;
                  margin-right: 10px;
                }
                .icon-title {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: bold;
                  font-size: 20px;
                  color: #26B9EA;
                  line-height: 50px;
                  font-style: normal;
                }
              }
              .content-summary{
                margin-top: 20px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                line-height: 20px;
                text-align: justify;
                font-style: normal;
              }
            }
          }
          .item-hide {
            background: #F2F2F6;
            box-shadow:none;
          }
        }
      }
    }
  }
  .dev-section{
    width: 100%;
    height: 700px;
    background: #FFFFFF;
    .dev-box {
      width: 66%;
      margin-left: 17%;
      padding-top: 100px;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 46px;
        color: #1A233B;
        text-align: left;
        font-style: normal;
      }
      .description {
        margin-top: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #797889;
        text-align: left;
        font-style: normal;
      }
      .dev-center{
        margin-top: 108px;
        .dev-row {
          height: 83px;
          display: flex;
          margin-bottom: 150px;
          .row-item {
            width: 21%;
            display: flex;
            .num {
              width: 55px;
              height: 83px;
              font-family: DINAlternate, DINAlternate;
              font-weight: bold;
              font-size: 50px;
              color: #26B9EA;
              line-height: 83px;
              text-align: left;
              font-style: normal;
              margin-right: 10px;
            }
            .item-content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              .dev-title {
                font-family: PingFangSC, PingFang SC;
                font-weight: bold;
                font-size: 20px;
                color: #333333;
                line-height: 30px;
                letter-spacing: 1px;
                text-align: left;
                font-style: normal;
              }
              .dev-descript {
                margin-top: 5px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #666666;
                line-height: 18px;
                text-align: left;
                font-style: normal;
              }
            }
          }
          .gap {
            width: 5.33%;
            display: flex;
            align-items: center;
            .icon {
              width: 30px;
              height: 16.5px;
            }
          }
        }
      }
    }
  }
  .contact-section{
    width: 100%;
    height: 500px;
    background: #F8F9FC;
    .contact-box {
      width: 66%;
      margin-left: 17%;
      display: flex;
      height: 100%;
      .left {
        flex:1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 32px;
          text-align: left;
          font-style: normal;
        }
        .description {
          margin-top: 44px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          line-height: 25px;
          text-align: justify;
          font-style: normal;
          padding-right: 30px;
        }
      }
      .right {
        flex:1;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
          display: block;       /* 消除图片默认的底部间隙 */
          height: 280px;        /* 固定高度（按需调整数值） */
          width: auto;          /* 宽度自适应（可不写，默认行为） */
          object-fit: contain;  /* 保持图片比例完整显示 */
        }
      }
    }
  }
  .contact-section2{
    width: 100%;
    height: 500px;
    background: #FFFFFF;
    .contact-box {
      width: 66%;
      margin-left: 17%;
      display: flex;
      height: 100%;
      .left {
        flex:1;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
          display: block;       /* 消除图片默认的底部间隙 */
          height: 280px;        /* 固定高度（按需调整数值） */
          width: auto;          /* 宽度自适应（可不写，默认行为） */
          object-fit: contain;  /* 保持图片比例完整显示 */
        }
      }
      .right {
        flex:1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        .title {
          padding-left: 50px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          font-size: 28px;
          color: #333333;
          line-height: 32px;
          text-align: left;
          font-style: normal;
        }
        .description {
          padding-left: 50px;
          margin-top: 44px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          line-height: 25px;
          text-align: justify;
          font-style: normal;
          padding-right: 30px;
        }
        .btn {
          cursor: pointer;
          width: 205px;
          height: 62px;
          margin-left: 50px;
          margin-top: 40px;
          background: #26B9EA;
          border-radius: 5px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 62px;
          text-align: center;
          font-style: normal;
        }
      }
    }
  }
  .app-developers-section {
    width: 100%;
    padding: 80px 0;
    background: #FFFFFF;
    .app-developers-box {
      width: 80%;
      margin: 0 auto;
      text-align: center;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 32px;
        color: #26233B;
        line-height: 40px;
        margin-bottom: 20px;
      }
      .description {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 17px;
        color: #8C8C8C;
        line-height: 20px;
        margin-bottom: 60px;
        max-width: 900px;
        margin-left: auto;
        margin-right: auto;
      }
      .app-logos-grid {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 20px;
        .app-logo-item {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          background: #FFFFFF;
          img {
            width: 72px;
            height: 72px;
            object-fit: contain;
          }
        }
      }
    }
  }
  .ad-developers-section {
    width: 100%;
    padding: 80px 0;
    background: #FFFFFF;
    .ad-developers-box {
      width: 80%;
      margin: 0 auto;
      text-align: center;
      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 32px;
        color: #26233B;
        line-height: 40px;
        margin-bottom: 20px;
      }
      .description {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 17px;
        color: #8C8C8C;
        line-height: 20px;
        margin-bottom: 60px;
        max-width: 900px;
        margin-left: auto;
        margin-right: auto;
      }
      .ad-logos-grid {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 20px;
        .ad-logo-item {
          display: flex;
          justify-content: center;
          align-items: center;
          background: #FFFFFF;
          border-radius: 8px;
          img {
            width: 160px;
            height: 66px;
            object-fit: contain;
          }
        }
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/Home.vue